import { useScrollReveal } from "@/hooks/useScrollReveal";
import React from "react";

export default function Simple() {
  const { ref, isVisible } = useScrollReveal();

  const steps = [
    {
      number: "1",
      title: "Submit your application",
      description: (
        <>
          Fill out a quick form (takes 5 minutes).<br />
          It's free to apply!
        </>
      ),
    },
    {
      number: "2",
      title: "We check your videos",
      description: (
        <>
          We review your videos to ensure they meet MSN’s guidelines. We’ll notify you once the review is complete.
        </>
      ),
    },
    {
      number: "3",
      title: "We post your videos",
      description: (
        <>
          Once approved, we upload your videos to MSN automatically. No extra work on your end.
        </>
      ),
    },
    {
      number: "4",
      title: "You get paid",
      description: (
        <>
          Monetization starts once<br />
          content goes live, with revenue<br />
          reported and paid monthly.
        </>
      ),
    },
  ];

  return (
    <div
      id="how-it-works"
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-12 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-[30px] text-center mb-16">
          {/* Label */}
          <p className="text-[#757575] text-[16px] 4xl:text-[24px] font-medium enfinity-subtext-font">
          Fast, simple, and stress free
          </p>

          {/* Main Heading */}
          <div className="text-3xl xxs:text-[55px] lg:text-[80px] 4xl:text-[80px] font-normal text-black leading-[106px] xxs:leading-normal xs:leading-normal sm:leading-normal md:leading-normal lg:leading-normal enfinity-header-font" style={{ lineHeight: "1.2" }}>
            <p className="mb-0">Super easy,</p>
            <p className="text-[#3b82f6]">we do all the work</p>
          </div>

          {/* Description */}
          <p className="text-lg xxs:text-[1rem] lg:text-[20px] font-normal text-black leading-[30px] max-w-[728px] enfinity-subtext-font">
            Setting up EnfiniBoost is quick and easy. Start monetizing your content once it goes live with MSN.
          </p>
        </div>

        {/* Steps Section */}
        <div className="grid grid-cols-1 gap-6 lg:grid lg:grid-cols-2 lg:gap-[25px] lg:overflow-x-visible xl:flex xl:flex-nowrap xl:overflow-x-auto 1xl:flex 1xl:flex-nowrap 2xl:flex 2xl:flex-nowrap enfinity-subtext-font">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex flex-col gap-[31px] items-center w-full lg:w-auto xl:w-[300px] 1xl:w-[300px] 2xl:w-[300px] text-center"
            >
              {/* Numbered Circle */}
              <div className="relative w-[75px] h-[75px]">
                <div 
                  className="absolute inset-0 rounded-full"
                  style={{
                    background: "linear-gradient(to bottom, #3B82F6, #2563EB)"
                  }}
                />
                <p className="absolute inset-0 flex items-center justify-center text-white text-[32px] font-extrabold">
                  {step.number}
                </p>
              </div>

              {/* Step Content */}
              <div className="flex flex-col gap-[19px] items-center text-black">
                <p className="text-[20px] font-medium leading-normal enfinity-header-font">
                  {step.title}
                </p>
                <div className="text-[16px] xxs:text-[1rem] lg:text-lg 4xl:text-[19px] font-normal leading-[28px] enfinity-subtext-font">
                  {step.description}
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
    </div>
  );
}

